import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 px-2 flex items-center justify-between text-left focus:outline-none" data-id="element-2">
        <span className="text-lg font-medium text-gray-900" data-id="element-3">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-4">
          <ChevronDown className="text-gray-500" data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-7">
            <div className="pb-6 px-2 text-gray-600 leading-relaxed" data-id="element-8">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}